var map = {
	"./sel_Beijing--.png": "ef87",
	"./sel_Beijing-.png": "3a8a",
	"./sel_Beijing.png": "4033",
	"./sel_Chengdu-.png": "fb1a",
	"./sel_Chengdu.png": "bad3",
	"./sel_Dalian-.png": "47bc",
	"./sel_Dalian.png": "9680",
	"./sel_Guangzhou-.png": "289b",
	"./sel_Guangzhou.png": "94fd",
	"./sel_Hangzhou-.png": "e820",
	"./sel_Hangzhou.png": "5cd3",
	"./sel_Hong Kong-.png": "9aab",
	"./sel_Hong Kong.png": "0958",
	"./sel_Shanghai-.png": "461c",
	"./sel_Shanghai.png": "2f06",
	"./sel_Shenzhen-.png": "aea9",
	"./sel_Shenzhen.png": "2bf7"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "ac1e";